/* Routing */
import {Link} from "react-router-dom";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import {deleteEstimateCategory, getEstimateCategoryList, updateCategoryStatus} from "../../../api/admin/estimateReq";
import useAuth from "../../../hooks/useAuth";
import {useEffect, useState} from "react";
import FormEstimateCategory from "../../../forms/admin/FormEstimateCategory";


export default function EstimateCategories({ tab }) {
    const sources = "fa fa-table-list";
    const tabSource = "fa fa-bars";
    const { auth } = useAuth();
    const token = auth.token;
    const [ estimateCategoryList, setEstimateCategoryList ] = useState();
    const [ showModal, setShowModal ] = useState(false);
    const [ catId, setCatId ] = useState(0);
    const buttons = document.getElementsByClassName('fa-pen-to-square');

    const apiCategoryList = async () => {
        const response = await getEstimateCategoryList(token)
        setEstimateCategoryList(response)
    }

    useEffect(() => {
        apiCategoryList()
    },[ token ] );

    const handleFormCategoryModal = (catId) => {
        setCatId(catId)
        setShowModal(true)
    }

    useEffect(() => {
        if (estimateCategoryList) {
            if (buttons && buttons.length > 0) {
                for (let button of buttons) {
                    button?.addEventListener('click', () => {
                        let id = button?.getAttribute('id')
                        handleFormCategoryModal(id)
                    })
                }
            }
        }
    }, [ buttons, estimateCategoryList ]);

    const handleDeleteCategory = async (e) => {
        e.preventDefault();
        const id = e.currentTarget.getAttribute("id");
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement une catégorie.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement cette catégorie ?")) {
                const body = {
                    "categoryId": parseInt(id),
                }
                await deleteEstimateCategory(token, body)
                    .then((response) => {
                        response.error && alert("La catégorie n'a pas pu être supprimée.")})
                        apiCategoryList()
            }
        }
    }

    const handleCategoryEnable = (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'une catégorie.");
        } else {
            const categoryId = parseInt(e.currentTarget.getAttribute("id"));
            const currentIsEnabled = e.currentTarget.classList.contains("fa-eye");

            if (currentIsEnabled) {
                let body = {
                    "categoryEnabled": true,
                    "categoryId": categoryId,
                }
                alert("Vous venez de désactiver cette catégorie.");
                updateCategoryStatus(token, body)
            } else {
                let body = {
                    "categoryEnabled": false,
                    "categoryId": categoryId,
                }
                alert("Vous venez d'activer cette catégorie.");
                updateCategoryStatus(token, body)
            }
        }
    };



    return (
        <main className="admin">
            <Header
                parent="Administration"
                location="Catégories"
                slug={`/admin/accueil`}
            />
            <div>
                { showModal &&
                    <div className="modal cat-infos">
                        <FormEstimateCategory apiEstimateCatList={apiCategoryList} catId={catId} setShowModal={setShowModal} legend="Informations d'une catégorie"/>
                    </div>
                }
                <nav className="tabs-menu">
                    <ul>
                        <li><Link to="/admin/documents">Voir les documents</Link></li>
                        <li><Link to="/admin/documents/courriers">Gérer les courriers</Link></li>
                        <li><Link to="/admin/documents/devis/section/1/voir">Voir les devis type</Link></li>
                        <li className="active"><Link to="/admin/documents/devis/categories">Gérer les catégories</Link>
                        </li>
                    </ul>
                </nav>
                <div className="content-container">
                    <Icon source={sources} color="blue" span="Liste des catégories de devis"/>
                    <div className="dashboard">
                        <div className="flex categories-add">
                            <button onClick={() => handleFormCategoryModal(0)} className="green-button"><i className="fa fa-plus"></i><span>Ajouter une catégorie</span></button>
                        </div>
                        <div className="dashboard">
                            <table>
                                <thead className="dashboard-header">
                                <tr>
                                    <th>Code</th>
                                    <th>Description</th>
                                    <th>Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                { estimateCategoryList?.map((category, index) => (
                                    <tr key={index}>
                                        <td>{category?.code}</td>
                                        <td>{category?.description}</td>
                                        <td className="actions">
                                            <i id={category?.id} onClick={() => handleFormCategoryModal(category?.id)}
                                               className="fa fa-pen-to-square"/>
                                            <i id={category?.id} onClick={handleDeleteCategory}
                                               className="fa fa-trash"/>
                                            <i
                                                id={category?.id}
                                                className={category?.enabled ? "fa fa-eye" : "fa fa-eye-slash"}
                                                onClick={handleCategoryEnable}
                                                title={category?.enabled ? "Catégorie visible - Cliquer pour masquer" : "Catégorie masquée - Cliquer pour rendre visible"}
                                            />
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}
